// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type ZahllaeufePage } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export type SucheZahllaeufeQuery = {
  zahllaufBezahlt?: boolean;
  search?: string;
  page?: number;
  limit?: number;
  sort?: string;
  filtered?: string;
};

export function useSucheZahllaeufe(): (
  query: SucheZahllaeufeQuery
) => Promise<ZahllaeufePage> {
  const getAPI = useGetApi();
  return useCallback(
    async (query = {}) =>
      (await getAPI()).zahllaeufe.sucheZahllaeufe({ ...query }),
    [getAPI]
  );
}
